import Guid from "common/values/guid/guid";
import moment, { Moment } from "moment";

export interface NetworkedGroupJSON {
  id: string;
  name?: string;
  description?: string;
  memberUserIds: string[];
  created: string;
}

export default class NetworkedGroup {
  readonly id: Guid;
  private _name?: string;
  private _description?: string;
  private _memberUserIds: Guid[] = [];
  readonly created: Moment;

  constructor(
    id: Guid,
    name: string | undefined,
    description: string | undefined,
    memberUserIds: Guid[],
    created: Moment
  ) {
    this.id = id;
    this._name = name;
    this._description = description;
    this._memberUserIds = memberUserIds;
    this.created = created;
  }

  public get name(): string | undefined {
    return this._name;
  }

  public get description(): string | undefined {
    return this._description;
  }

  public get memberUserIds(): Guid[] {
    return this._memberUserIds;
  }

  public updateName(newName: string | undefined): void {
    this._name = newName;
  }

  public updateDescription(newDescription: string | undefined): void {
    this._description = newDescription;
  }

  public addMember(userId: Guid): void {
    if (!this._memberUserIds.includes(userId)) {
      this._memberUserIds.push(userId);
    }
  }

  public removeMember(userId: Guid): void {
    this._memberUserIds = this._memberUserIds.filter(id => id !== userId);
  }

  public static fromJSON(json: NetworkedGroupJSON): NetworkedGroup {
    return new NetworkedGroup(
      Guid.fromJSON(json.id),
      json.name,
      json.description,
      Array.isArray(json?.memberUserIds) ? json.memberUserIds.map((id: string) => new Guid(id)) : [],
      moment(json?.created)
    );
  }

  public toJSON(): NetworkedGroupJSON {
    return {
      id: this.id.toString(),
      name: this._name,
      description: this._description,
      memberUserIds: this._memberUserIds.map(id => id.toString()),
      created: this.created.toISOString()
    };
  }
}
